import Game from "./Game.js";

export default class Game_Ruler
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        this.scene = scene;

        this.rulerImage = this.scene.addImage(this.scene.mid.x - 65, this.scene.size.height - 65, "make_ruler1");
        this.ruler_pointer = this.scene.addImage(this.scene.mid.x - 457, this.scene.size.height - 45, "make_ruler_pointer");

        this.pointerX_Min = this.scene.mid.x - 457;
        this.pointerX_Max = this.scene.mid.x + 320;

        this.maxValue_1 = 10;
        this.maxValue_10 = 100;
        this.maxValue_100 = 500;

        this.maxValue = 0;
        this.curValue = 0;
    }

    setRuler(units)
    {
        if(units == 1)
        {
            this.rulerImage.setFrame("make_ruler1", false, false);
            this.maxValue = this.maxValue_1;
        }
        else if(units == 10)
        {
            this.rulerImage.setFrame("make_ruler10", false, false);
            this.maxValue = this.maxValue_10;
        }
        else
        {
            this.rulerImage.setFrame("make_ruler100", false, false);
            this.maxValue = this.maxValue_100;
        }
    }

    reset()
    {
        this.scene.killTween(this.ruler_pointer);
        this.scene.addTween(this.ruler_pointer, 500, {x: this.pointerX_Min}, Phaser.Math.Easing.Sine.Out);
    }

    setAmount(amount)
    {
        this.curValue = amount;

        let xPos = ((this.pointerX_Max - this.pointerX_Min) * (this.curValue / this.maxValue)) + this.pointerX_Min;

        this.scene.killTween(this.ruler_pointer);
        this.scene.addTween(this.ruler_pointer, 500, {x: xPos}, Phaser.Math.Easing.Sine.Out);
    }
}